(function () {
  'use strict';

  var pendingMaxAge = 30 * 60 * 1000;
  var pendingPrefix = 'cityOpticsOfferLeadPending:';
  var handoffCounter = 0;
  var appScanScheduled = false;

  function readConfig() {
    var node = document.getElementById('CityOfferBookingConfig');
    if (!node) return { stores: {} };

    try {
      var parsed = JSON.parse(node.textContent || '{}');
      return parsed && parsed.stores ? parsed : { stores: {} };
    } catch (error) {
      return { stores: {} };
    }
  }

  function normaliseStore(value) {
    var input = String(value || '').trim().toLowerCase();
    if (!input) return '';
    if (input === 'penrith' || input.indexOf('penrith westfield') !== -1 || input.indexOf('westfield penrith') !== -1) return 'penrith';
    if (input === 'wetherill' || input.indexOf('wetherill park') !== -1) return 'wetherill';
    if (input === 'nepean' || input.indexOf('nepean village') !== -1) return 'nepean';
    if (input === 'kotara' || input.indexOf('kotara') !== -1) return 'kotara';
    return '';
  }

  function preferenceType(value) {
    var input = String(value || '').trim().toLowerCase();
    if (input === 'no' || input.indexOf('need a new eye test') !== -1 || input.indexOf('book an eye test') !== -1) return 'new_eye_test';
    if (input === 'yes' || input.indexOf('recent prescription') !== -1) return 'recent_prescription';
    return '';
  }

  function getSelectedPreference(form) {
    var checked = form && form.querySelector(
      '[name="contact[hasPrescription]"]:checked, fieldset[name*="prescription" i] input[type="radio"]:checked, input[type="radio"][value*="eye test" i]:checked, input[type="radio"][value*="prescription" i]:checked'
    );
    return checked ? checked.value : '';
  }

  function getSelectedStore(form, root) {
    var fixedStore = normaliseStore(
      (root && root.dataset.offerFixedStore) ||
      (document.body && document.body.dataset.cityOfferFixedStore)
    );
    if (fixedStore) return fixedStore;
    if (!form) return '';

    var branchField = form.querySelector('[name="contact[branch]"]:checked, [name="contact[branch]"]');
    if (branchField) {
      var fieldStore = normaliseStore(branchField.value);
      if (fieldStore) return fieldStore;
      if (branchField.options && branchField.selectedIndex >= 0) {
        fieldStore = normaliseStore(branchField.options[branchField.selectedIndex].textContent);
        if (fieldStore) return fieldStore;
      }
    }

    var locationFields = form.querySelectorAll('select[name*="location" i], input[name*="location" i]:checked');
    for (var index = 0; index < locationFields.length; index += 1) {
      var locationStore = normaliseStore(locationFields[index].value);
      if (locationStore) return locationStore;
      if (locationFields[index].options && locationFields[index].selectedIndex >= 0) {
        locationStore = normaliseStore(locationFields[index].options[locationFields[index].selectedIndex].textContent);
        if (locationStore) return locationStore;
      }
    }

    return '';
  }

  function getStore(storeKey) {
    var config = readConfig();
    var store = config.stores[normaliseStore(storeKey)];
    if (!store || !store.label || !store.booking_url) return null;
    return {
      key: normaliseStore(storeKey),
      label: String(store.label),
      bookingUrl: String(store.booking_url)
    };
  }

  function buildBaseEvent(root, form, fallbackFormId) {
    return {
      offer_id: root.dataset.offerId || 'winter-multifocal-2026',
      offer_source: root.dataset.offerSource || window.location.pathname,
      page_path: window.location.pathname,
      form_id: (form && form.id) || root.dataset.offerFormId || fallbackFormId || ''
    };
  }

  function track(root, baseEvent, eventName, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, baseEvent, extra || {}));
    root.dataset.offerLastEvent = eventName;
  }

  function pendingKey(formId) {
    return pendingPrefix + formId;
  }

  function writePending(formId, payload) {
    try {
      sessionStorage.setItem(pendingKey(formId), JSON.stringify(payload));
    } catch (error) {
      /* The original lead submission continues when browser storage is unavailable. */
    }
  }

  function readPending(formId) {
    try {
      return JSON.parse(sessionStorage.getItem(pendingKey(formId)) || 'null');
    } catch (error) {
      try {
        sessionStorage.removeItem(pendingKey(formId));
      } catch (storageError) {
        /* Ignore storage cleanup failures. */
      }
      return null;
    }
  }

  function clearPending(formId) {
    try {
      sessionStorage.removeItem(pendingKey(formId));
    } catch (error) {
      /* Ignore storage cleanup failures. */
    }
  }

  function matchingPending(baseEvent) {
    var pending = readPending(baseEvent.form_id);
    if (!pending) return null;

    var isFresh = Number.isFinite(pending.submitted_at) && Date.now() - pending.submitted_at < pendingMaxAge;
    if (!isFresh) {
      clearPending(baseEvent.form_id);
      return null;
    }

    if (
      pending.offer_id !== baseEvent.offer_id ||
      pending.page_path !== baseEvent.page_path ||
      pending.offer_source !== baseEvent.offer_source ||
      pending.form_id !== baseEvent.form_id
    ) return null;

    return pending;
  }

  function setSubmitting(root, form, manageSubmitter) {
    if (root.dataset.offerSubmitting === 'true') return false;
    root.dataset.offerSubmitting = 'true';

    if (manageSubmitter === false) return true;

    var submitter = form && form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitter) {
      root.__cityOfferSubmitter = submitter;
      submitter.dataset.offerOriginalLabel = submitter.tagName === 'INPUT' ? submitter.value : submitter.textContent;
      window.setTimeout(function () {
        if (root.dataset.offerSubmitting !== 'true') return;
        submitter.disabled = true;
        submitter.setAttribute('aria-disabled', 'true');
        submitter.setAttribute('aria-busy', 'true');
        if (submitter.tagName === 'INPUT') submitter.value = 'Sending…';
        else submitter.textContent = 'Sending…';
      }, 0);
    }
    return true;
  }

  function clearSubmitting(root) {
    root.dataset.offerSubmitting = 'false';
    var submitter = root.__cityOfferSubmitter || root.querySelector('button[type="submit"], input[type="submit"]');
    if (!submitter) return;

    submitter.disabled = false;
    submitter.removeAttribute('aria-disabled');
    submitter.removeAttribute('aria-busy');
    if (submitter.dataset.offerOriginalLabel) {
      if (submitter.tagName === 'INPUT') submitter.value = submitter.dataset.offerOriginalLabel;
      else submitter.textContent = submitter.dataset.offerOriginalLabel;
    }
    root.__cityOfferSubmitter = null;
  }

  function createElement(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function renderBookingHandoff(root, target, pending, baseEvent) {
    var store = getStore(pending.branch);
    if (!store) return false;

    handoffCounter += 1;
    var headingId = 'co-booking-handoff-heading-' + handoffCounter;
    var state = createElement('div', 'co-booking-handoff');
    state.setAttribute('role', 'status');
    state.setAttribute('aria-live', 'polite');
    state.setAttribute('aria-labelledby', headingId);
    state.setAttribute('tabindex', '-1');
    state.dataset.offerBookingHandoff = 'true';
    state.dataset.offerBookingStore = store.key;

    state.appendChild(createElement('p', 'co-booking-handoff__eyebrow', 'Offer request received'));
    var heading = createElement('h3', '', 'Your details have been received');
    heading.id = headingId;
    state.appendChild(heading);
    state.appendChild(createElement(
      'p',
      'co-booking-handoff__received-copy',
      'We have your details and will contact you if you don’t book online.'
    ));

    var meta = createElement('dl', 'co-booking-handoff__meta');
    var storeMeta = createElement('div');
    storeMeta.appendChild(createElement('dt', '', 'Selected store'));
    storeMeta.appendChild(createElement('dd', '', store.label));
    meta.appendChild(storeMeta);
    var typeMeta = createElement('div');
    typeMeta.appendChild(createElement('dt', '', 'Appointment'));
    typeMeta.appendChild(createElement('dd', '', 'New eye test'));
    meta.appendChild(typeMeta);
    state.appendChild(meta);

    var prompt = createElement('div', 'co-booking-handoff__prompt');
    prompt.appendChild(createElement('h4', '', 'Would you like to choose a time now?'));
    var bookingLink = createElement('a', 'co-booking-handoff__cta');
    bookingLink.href = store.bookingUrl;
    bookingLink.dataset.offerBookingCta = 'true';
    bookingLink.appendChild(document.createTextNode('Continue to online booking '));
    var externalIcon = createElement('span', 'co-booking-handoff__external-icon', '↗');
    externalIcon.setAttribute('aria-hidden', 'true');
    bookingLink.appendChild(externalIcon);
    bookingLink.appendChild(createElement(
      'span',
      'co-booking-visually-hidden',
      ' Opens our external booking page in this tab.'
    ));
    bookingLink.addEventListener('click', function () {
      track(root, baseEvent, 'offer_form_booking_click', {
        branch: store.key,
        lead_preference: 'new_eye_test',
        booking_url: store.bookingUrl
      });
    });
    prompt.appendChild(bookingLink);
    prompt.appendChild(createElement('p', 'co-booking-handoff__support', 'Opens our external booking page'));

    var notNow = createElement('button', 'co-booking-handoff__not-now', 'Not now — I’ll wait for a call');
    notNow.type = 'button';
    notNow.addEventListener('click', function () {
      track(root, baseEvent, 'offer_form_not_now_click', {
        branch: store.key,
        lead_preference: 'new_eye_test'
      });
      state.classList.add('co-booking-handoff--declined');
      state.focus();
    });
    prompt.appendChild(notNow);
    state.appendChild(prompt);

    if (target === root) root.replaceChildren(state);
    else target.replaceWith(state);

    window.setTimeout(function () { state.focus(); }, 0);
    return true;
  }

  function confirmSubmission(root, target, baseEvent) {
    var pending = matchingPending(baseEvent);
    if (!pending) return false;

    track(root, baseEvent, 'offer_form_submit', {
      branch: pending.branch || '',
      lead_preference: pending.lead_preference || ''
    });

    if (pending.appointment_type === 'new_eye_test') {
      renderBookingHandoff(root, target, pending, baseEvent);
    }
    clearPending(baseEvent.form_id);
    return true;
  }

  function renameEyeTestChoice(form) {
    if (!form) return;
    var radios = form.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      if (preferenceType(radio.value) !== 'new_eye_test') return;
      if (radio.getAttribute('aria-label') !== 'I need a new eye test') {
        radio.setAttribute('aria-label', 'I need a new eye test');
      }
      var label = radio.closest('label');
      var visibleText = label && label.querySelector('span');
      if (visibleText && visibleText.textContent !== 'I need a new eye test') {
        visibleText.textContent = 'I need a new eye test';
      }
    });
  }

  function capturePending(root, form, baseEvent) {
    var preference = getSelectedPreference(form);
    var branch = getSelectedStore(form, root);
    writePending(baseEvent.form_id, {
      offer_id: baseEvent.offer_id,
      offer_source: baseEvent.offer_source,
      page_path: baseEvent.page_path,
      form_id: baseEvent.form_id,
      branch: branch,
      lead_preference: preference,
      appointment_type: preferenceType(preference),
      submitted_at: Date.now()
    });
  }

  function initNativeRoot(root) {
    if (root.dataset.offerTrackingReady === 'true') return;
    root.dataset.offerTrackingReady = 'true';

    var details = root.querySelector('[data-offer-lead-details], [data-offer-accordion]');
    var panelTrigger = root.querySelector('[data-offer-lead-trigger]');
    var panelTriggerLabel = root.querySelector('[data-offer-lead-trigger-label]');
    var panel = root.querySelector('[data-offer-lead-panel]');
    var form = root.querySelector('form');
    var success = root.querySelector('[data-offer-lead-success], [data-offer-native-success]');
    var baseEvent = buildBaseEvent(root, form, root.dataset.offerFormId || '');

    function setPanelExpanded(expanded) {
      if (panelTrigger) panelTrigger.setAttribute('aria-expanded', String(expanded));
      if (panelTriggerLabel) {
        panelTriggerLabel.textContent = expanded
          ? panelTriggerLabel.dataset.expandedLabel
          : panelTriggerLabel.dataset.collapsedLabel;
      }
    }

    function positionFormHeading() {
      var heading = panel && panel.querySelector('[data-offer-lead-form-heading]');
      if (!heading) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(function () {
        var rect = heading.getBoundingClientRect();
        if (rect.top < 96 || rect.bottom > window.innerHeight - 24) {
          heading.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      }, reduceMotion ? 0 : 120);
    }

    if (success) {
      if (details) details.open = true;
      if (panel) panel.hidden = false;
      setPanelExpanded(true);
      confirmSubmission(root, success.closest('form') || success, baseEvent);
      window.setTimeout(function () {
        var focusTarget = root.querySelector('[data-offer-booking-handoff], [data-offer-lead-success], [data-offer-native-success]');
        if (focusTarget) focusTarget.focus();
      }, 0);
      return;
    }

    renameEyeTestChoice(form);

    var viewed = false;
    var started = false;

    function trackView() {
      if (viewed) return;
      viewed = true;
      var expanded = details ? details.open : (panel ? !panel.hidden : true);
      track(root, baseEvent, 'offer_form_view', { form_expanded: String(expanded) });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          trackView();
          observer.disconnect();
        }
      }, { threshold: 0.05 });
      observer.observe(root);
    } else {
      trackView();
    }

    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) track(root, baseEvent, 'offer_form_open');
      });
    }

    if (panelTrigger && panel) {
      panelTrigger.addEventListener('click', function () {
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        setPanelExpanded(willOpen);
        if (willOpen) {
          track(root, baseEvent, 'offer_form_open');
          positionFormHeading();
        }
      });
    }

    root.addEventListener('focusin', function () {
      if (started) return;
      started = true;
      track(root, baseEvent, 'offer_form_start');
    });

    if (!form) return;

    form.addEventListener('submit', function (event) {
      if (root.dataset.offerSubmitting === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      capturePending(root, form, baseEvent);
      setSubmitting(root, form);
    }, true);
  }

  function appFormContext(component) {
    var componentRoot = component.getRootNode ? component.getRootNode() : document;
    var shadowHost = componentRoot instanceof ShadowRoot ? componentRoot.host : null;
    var root = (shadowHost && shadowHost.closest('[data-offer-form-root], [data-offer-lead-module]')) ||
      (shadowHost && shadowHost.closest('.shopify-section')) ||
      component.closest('.shopify-section') ||
      shadowHost ||
      component.closest('section[role="dialog"]');
    return { root: root, componentRoot: componentRoot };
  }

  function initAppRoot(component) {
    var context = appFormContext(component);
    var root = context.root;
    if (!root || root.dataset.offerAppTrackingReady === 'true') return;
    var appDocument = context.componentRoot;
    var form = appDocument.querySelector('form[data-testid="form"]');
    if (!form) return;

    var preferenceRadios = form.querySelectorAll('input[type="radio"]');
    var hasOfferPreference = Array.from(preferenceRadios).some(function (radio) {
      return preferenceType(radio.value) !== '';
    });
    if (!hasOfferPreference) return;

    root.dataset.offerAppTrackingReady = 'true';
    root.dataset.offerId = root.dataset.offerId || 'winter-multifocal-2026';
    root.dataset.offerSource = root.dataset.offerSource || ((document.body.dataset.cityOfferFixedStore || 'website') + '-shopify-form');
    root.dataset.offerFixedStore = root.dataset.offerFixedStore || document.body.dataset.cityOfferFixedStore || '';

    var fallbackFormId = root.id || (component && component.dataset.instanceId) || ('ShopifyForms-' + window.location.pathname);
    var baseEvent = buildBaseEvent(root, form, fallbackFormId);
    var confirmed = false;
    var observer;
    var releaseTimer;
    renameEyeTestChoice(form);

    function maybeReleaseAfterError() {
      var currentForm = appDocument.querySelector('form[data-testid="form"]');
      if (!currentForm) return;
      renameEyeTestChoice(currentForm);
      if (currentForm.querySelector('[aria-invalid="true"], [role="alert"]')) clearSubmitting(root);
    }

    function maybeConfirm() {
      if (confirmed || root.dataset.offerSubmitting !== 'true') return;
      var currentForm = appDocument.querySelector('form[data-testid="form"]');
      if (currentForm) {
        maybeReleaseAfterError();
        return;
      }
      var success = appDocument.querySelector('[data-current-step="success"], [data-testid="banner-success"]');
      if (!success) return;

      confirmed = true;
      if (releaseTimer) window.clearTimeout(releaseTimer);
      if (observer) observer.disconnect();
      confirmSubmission(root, root, baseEvent);
    }

    appDocument.addEventListener('submit', function (event) {
      var submittedForm = event.target;
      if (!(submittedForm instanceof HTMLFormElement) || !submittedForm.matches('form[data-testid="form"]')) return;
      if (root.dataset.offerSubmitting === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      capturePending(root, submittedForm, baseEvent);
      setSubmitting(root, submittedForm, false);
      window.setTimeout(maybeReleaseAfterError, 600);
      if (releaseTimer) window.clearTimeout(releaseTimer);
      releaseTimer = window.setTimeout(function () {
        var successMarker = appDocument.querySelector('[data-current-step="success"], [data-testid="banner-success"]');
        if (!confirmed && !successMarker) clearSubmitting(root);
      }, Number(root.dataset.offerAppReleaseDelay) || 20000);
    }, true);

    observer = new MutationObserver(function () {
      window.setTimeout(maybeConfirm, 50);
    });
    observer.observe(appDocument, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  function scanRoot(scanTarget) {
    scanTarget.querySelectorAll('shop-lead-capture').forEach(initAppRoot);
    scanTarget.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      if (!host.shadowRoot) return;
      if (host.dataset.offerShadowObserved !== 'true') {
        host.dataset.offerShadowObserved = 'true';
        new MutationObserver(scheduleAppScan).observe(host.shadowRoot, { childList: true, subtree: true });
      }
      scanRoot(host.shadowRoot);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-offer-lead-module], [data-offer-form-root]').forEach(initNativeRoot);
    scanRoot(document);
  }

  function scheduleAppScan() {
    if (appScanScheduled) return;
    appScanScheduled = true;
    window.requestAnimationFrame(function () {
      appScanScheduled = false;
      initAll();
    });
  }

  if (window.CityOpticsOfferTracking) {
    window.CityOpticsOfferTracking.init();
    return;
  }

  window.CityOpticsOfferTracking = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      if (document.body) new MutationObserver(scheduleAppScan).observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    initAll();
    if (document.body) new MutationObserver(scheduleAppScan).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-offer-submitting="true"]').forEach(clearSubmitting);
  });
}());
